import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const { REACT_APP_DB, REACT_APP_PORT_BACK, REACT_APP_FROM } = process.env;

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [strength, setStrength] = useState({ level: 0, label: "", color: "" });
  const [message, setMessage] = useState("");

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  // ✅ ฟังก์ชันวัดความแข็งแรงของรหัสผ่าน
  const checkPasswordStrength = (password) => {
    let level = 0;

    if (password.length >= 6) level++;
    if (/[A-Z]/.test(password)) level++;
    if (/[a-z]/.test(password)) level++;
    if (/\d/.test(password)) level++;
    if (/[@$!%*?&]/.test(password)) level++;

    if (level <= 3) return { level, label: "อ่อน", color: "red" };
    if (level === 4) return { level, label: "ปานกลาง", color: "orange" };
    if (level >= 5) return { level, label: "แข็งแรง", color: "green" };
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setStrength(checkPasswordStrength(value));
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage("❌ รหัสผ่านไม่ตรงกัน");
      return;
    }

    if (!validatePassword(password)) {
      setMessage(
        "❌ รหัสผ่านต้องมีอักษรพิมพ์ใหญ่ พิมพ์เล็ก ตัวเลข อักขระพิเศษ และยาวอย่างน้อย 6 ตัวอักษร",
      );
      return;
    }

    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/reset-password`
          : `/api/reset-password`;

      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();
      if (data.success) {
        setMessage("✅ รีเซ็ตรหัสผ่านสำเร็จ");
      } else {
        setMessage(data.message || "❌ เกิดข้อผิดพลาด");
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
    }
  };

  return (
    <div
      style={{ maxWidth: "400px", margin: "50px auto", textAlign: "center" }}
    >
      <h2>🔐 Reset Password</h2>
      <form onSubmit={handleSubmit}>
        {/* ช่องรหัสผ่านใหม่ */}
        <div style={{ position: "relative", marginBottom: "10px" }}>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="รหัสผ่านใหม่"
            value={password}
            onChange={handlePasswordChange}
            required
            style={{
              width: "100%",
              padding: "8px 35px 8px 8px",
              boxSizing: "border-box",
            }}
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
              userSelect: "none",
            }}
          >
            {showPassword ? "👁️" : "🚫"}
          </span>
        </div>

        {/* 🔋 แถบวัดความแข็งแรงของรหัสผ่าน */}
        {password && (
          <div style={{ marginBottom: "10px" }}>
            <div
              style={{
                height: "6px",
                borderRadius: "4px",
                backgroundColor: "#ddd",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${(strength.level / 5) * 100}%`,
                  backgroundColor: strength.color,
                  borderRadius: "4px",
                  transition: "width 0.3s ease",
                }}
              ></div>
            </div>
            <small style={{ color: strength.color }}>{strength.label}</small>
          </div>
        )}

        {/* ช่องยืนยันรหัสผ่าน */}
        <div style={{ position: "relative", marginBottom: "10px" }}>
          <input
            type={showConfirm ? "text" : "password"}
            placeholder="ยืนยันรหัสผ่าน"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "8px 35px 8px 8px",
              boxSizing: "border-box",
            }}
          />
          <span
            onClick={() => setShowConfirm(!showConfirm)}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
              userSelect: "none",
            }}
          >
            {showConfirm ? "👁️" : "🚫"}
          </span>
        </div>

        <button type="submit" style={{ padding: "8px 16px" }}>
          ยืนยัน
        </button>
      </form>

      {message && (
        <p
          style={{
            marginTop: "15px",
            color: message.startsWith("✅") ? "green" : "red",
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default ResetPassword;
